import React, { useState, useEffect } from "react";

import { editBusiness } from "../../utils/ParserUtilities";
import { getBase64 } from "../../utils/image";
import MainModal from "./MainModal";
import Button from "../button/Button";
import { Input } from "jobin-ui-components";
import { useStateValue } from "../../state/context";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng
} from "react-places-autocomplete";
import { SearchBar } from "jobin-ui-components";

import '../../styles/modal/new-business-modal.css';

const EditBusinessModal = ({ isVisible, onClose, businessData }) => {
    const [{ agent }, dispatch] = useStateValue();

    const [loading, setLoading] = useState(false);
    const [businessName, setbusinessName] = useState()
    const [level, setLevel] = useState()
    const [map, setMap] = useState(undefined)
    const [addressSelected, setAddressSelected] = useState()
    const [coordinates, setCoordinates] = useState()
    const [logo, setlogo] = useState()
    const [landingLogo, setLandingLogo] = useState()
    const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);

    const [levels, setLevels] = useState([1, 2, 3, 4, 5, 6])

    useEffect(() => {
         

        if ( businessName != undefined ||
             level != undefined ||
             addressSelected != undefined ||
             logo != undefined ||
             landingLogo != undefined) {
            setSaveBtnDisabled(false);
        }else{
            setSaveBtnDisabled(true)
        }
    }, [businessName,
        level,
        addressSelected,
        logo,
        landingLogo]);


    const handleChangeBusiness = async () => {
        setLoading(true);
       
        try {
            let data = {
                businessId: businessData.id,
                businessName: businessName != undefined ? businessName :null,
                level: level != undefined ? level :null,
                addressSelected: addressSelected != undefined ? addressSelected :null,
                coordinates: coordinates ? coordinates:null,
                logo: logo != undefined ? logo :null,
                landingLogo: landingLogo != undefined ? landingLogo :null,
                agentId: agent.agentId
            }
            let result = await editBusiness(data)
            if (result) {
                dispatch({
                    type: "BUSINESS_DETAIL",
                    business: result.result
                });
                onClose()
            }
        } catch (error) {
            console.error(error)
            setLoading(false)
        }

    }
    const handlePhotos = async (file, reason) => {
        file = [...file].pop()
        switch (reason) {
            case "logo":
                setlogo(await getBase64(file))
                break;
            case "landingLogo":
                setLandingLogo(await getBase64(file))
                break;

            default:
                break;
        }
    }
    const removePhotos = async (reason) => {
        switch (reason) {
            case "logo":
                setLogo(null)
                break;
            case "landingLogo":
                setLandingLogo(null)
                break;

            default:
                break;
        }
    }
    const handleChange = address => {
        setMap(address);
        setAddressSelected(false);

    };
    const handleSelect = async address => {
        try {
            let results = await geocodeByAddress(address);
            results = results.pop()

            const latLng = await getLatLng(results);

            setCoordinates(
                {
                    lat: latLng.lat,
                    lng: latLng.lng
                }
            )
            setAddressSelected(results.formatted_address)
        } catch (error) {
            setError(error);
        }
    };

    const searchOptions = {
        types: ["address"],
        componentRestrictions: { country: ["es"] }
    };

    return (
        <MainModal
            title={"Editar Business."}
            subtitle={"Edita la información del Business."}
            isVisible={isVisible}
            onClose={onClose}
            big={true}
            classNamesModal={{ modal: "new-business-modal" }}
        >
            <div >
                {/* Business name */}
                <div className="container-input">
                    <div className="input-slot triple">
                        <label className="subTitle">{"Nombre del Business."}</label>
                        <Input
                            onChange={e => setbusinessName(e.target.value)}
                            defaultValue={businessName ? businessName: businessData?.get("Name")}
                        />
                    </div>
                    <div className="input-slot triple">
                        <label className="subTitle">{"Selecciona el nivel"}</label>
                        <select
                            value={level ? level:businessData.get("Level")}
                            onChange={(event) => setLevel(parseInt(event.target.value))}
                            defaultValue={undefined}
                        >
                            <option value={false}  >Selecciona un nivel</option>
                            {levels?.map((level_) => {
                                return (<option key={level_} value={level_}>{level_}</option>)
                            })}

                        </select>
                    </div>
                </div>

                {/* map */}
                {!addressSelected && (<div className="container-input">
                    <div className="input-slot unique">
                        <label className="subTitle">{"Introduce la dirección del Business."}</label>
                        <PlacesAutocomplete
                            value={map}
                            onChange={handleChange}
                            onSelect={handleSelect}
                            searchOptions={searchOptions}
                            style={{ marginTop: 0 }}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div className="p-relative search-address">
                                    <SearchBar
                                        {...getInputProps({ placeholder: "Escribe la dirección exacta" })}
                                    />
                                    <div
                                        className={suggestions.length > 0
                                            ? "autocomplete-dropdown-container ready"
                                            : "autocomplete-dropdown-container"
                                        }
                                    >
                                        {loading && <div>Cargando...</div>}
                                        {suggestions.map(suggestion => {
                                            const className = suggestion.active
                                                ? "suggestion-item active"
                                                : "suggestion-item";
                                            return (
                                                <div
                                                    {...getSuggestionItemProps(
                                                        suggestion,
                                                        {
                                                            className
                                                        }
                                                    )}
                                                >
                                                    <span>{suggestion.description}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </PlacesAutocomplete>
                    </div>
                </div>)}
                {(addressSelected || businessData.get("Address")) && (<div className="container-input">
                    <div className="input-slot unique" >
                        <label className="subTitle">{"Dirección seleccionada"}</label>
                        <p className="addres-selected" onClick={() => { setAddressSelected(undefined); setMap(null) }}>{addressSelected ? addressSelected : businessData.get("Address")}</p>
                    </div>
                </div>)}
                {/* logo and landing logo */}
                <div className="container-input">
                    <div className="input-slot triple photos">
                        <label htmlFor="logo" className="add-photos">  Selecciona el logo para el landing.</label>
                        <input type="file" id="logo" accept="image/jpeg, image/png" onChange={(event) => handlePhotos(event.target.files, "logo")} />
                        <div className="photo-container">
                            {(logo || businessData.get("Logo")) && (<img
                                className="photo"
                                src={!logo ? businessData.get("Logo").url() : logo.base64}
                                alt="photo" onClick={() => removePhotos("logo")}
                            />)}
                        </div>
                    </div>
                    <div className="input-slot triple photos">
                        <label htmlFor="landing" className="add-photos"> Selecciona el logo del Business.</label>
                        <input type="file" id="landing" accept="image/jpeg, image/png" onChange={(event) => handlePhotos(event.target.files, "landingLogo")} />
                        <div className="photo-container">
                            {(landingLogo || businessData.get("LandingLogo")) && (<img
                                className="photo"
                                src={!landingLogo ? businessData.get("LandingLogo").url() : landingLogo.base64}
                                alt="photo" onClick={() => removePhotos("landingLogo")}
                            />)}
                        </div>
                    </div>
                </div>
            </div>

            <Button
                style={{ margin: " 16px auto 0" }}
                disabled={saveBtnDisabled}
                buttonText="Editar Business"
                onClick={handleChangeBusiness}
                loading={loading}
            />

        </MainModal>
    );
};

export default EditBusinessModal;